module.exports = __webpack_public_path__ + "0791b3d436d8592ed3433b501a1c3810.jpg";